import React, { useState } from "react";
import BackButton from "../../Components/BackButton/BackButton.module";
import styles from "./LearningCenter.module.css";
import EachLearningCard from "./components/EachLearningCard/EachLearningCard.module";
import VideoPlayer from "./components/VideoPlayer/VideoPlayer.module";
const LearninCenter = () => {
  const [openVideo, setOpenVideo] = useState(null);
  const blogs = [
    // OPEN VPN
    {
      id: "1",
      title: "نحوه اضافه کردن پروفایل اوپن وی‌پی‌ان (iOS)",
      img: "/asets/pradd.png",
      description: "یاد بگیر چطوری پروفایل OpenVpn رو روی گوشیت اضافه کنی",
      video: "/vids/ovpn-ios.mp4",
    },
    {
      id: "2",
      title: "نحوه اضافه کردن پروفایل اوپن وی پی ان (اندروید) ",
      img: "/asets/pradd.png",
      description: "یاد بگیر چطوری پروفایل OpenVpn رو روی گوشیت  اضافه کنی",
      video: "/vids/ovpn-android.mp4",
    },
    // {
    //   id: "3",
    //   title: "نحوه اضافه کردن پروفایل اوپن وی پی ان (مک و ویندوز)",
    //   img: "/asets/pradd.png",
    //   description: "یاد بگیر چطوری پروفایل OpenVpn رو روی سیستمت  اضافه کنی",
    //   video:
    //     "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
    // },
    //WIREGUARD

    {
      id: "4",
      title: "نحوه اضافه کردن پروفایل وایرگارد (iOS)",
      img: "/asets/wireguard.png",
      description: "یاد بگیر چطوری پروفایل Wireguard رو روی گوشیت  اضافه کنی",
      video: "/vids/ios-irluxe.MP4",
    },
    {
      id: "5",
      title: "نحوه اضافه کردن پروفایل وایرگارد (اندروید)",
      img: "/asets/wireguard.png",
      description: "یاد بگیر چطوری پروفایل Wireguard رو روی گوشیت  اضافه کنی",
      video: "/vids/android-irluxe.mp4",
    },
    {
      id: "6",
      title: "نحوه اضافه کردن پروفایل وایرگارد (مک و ویندوز)",
      img: "/asets/wireguard.png",
      description: "یاد بگیر چطوری پروفایل Wireguard رو روی سیستمت  اضافه کنی",
      video: "/vids/winmac.mp4",
    },
    // File Share OPEN VPN
    {
      id: "7",
      title: "نحوه شبکه کردن فایل ها با اوپن وی پی ان (مک)",
      img: "/asets/ovpn-share.png",
      description:
        "یاد بگیر چطور فایل‌هات رو در شبکه داخلی و از راه دور با امنیت کامل به اشتراک بذاری.",
      video: "/vids//NetworkingFiles-MAC.mp4",
    },
    // {
    //   id: "8",
    //   title: "نحوه شبکه کردن فایل ها با اوپن وی پی ان (ویندوز)",
    //   img: "/asets/ovpn-share.png",
    //   description:
    //     "یاد بگیر چطور فایل‌هات رو در شبکه داخلی و از راه دور با امنیت کامل به اشتراک بذاری.",
    //   video:
    //     "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
    // },
  ];

  return (
    <>
      <BackButton />
      <div className={styles.mainLearning}>
        <div className={styles.learningTitle}> آموزش ها</div>
        <div className={styles.learningCards}>
          {blogs?.map((item) => (
            <EachLearningCard
              title={item.title}
              img={item.img}
              description={item.description}
              key={item.id}
              onPlay={() => setOpenVideo(item.video)}
            />
          ))}
        </div>
        <VideoPlayer
          open={!!openVideo}
          url={openVideo}
          onClose={() => setOpenVideo(null)}
        />
      </div>
    </>
  );
};

export default LearninCenter;
